export default "__VITE_ASSET__C82aMzeo__"